import React from 'react';
import { FooterQuickLinks } from '../FooterQuickLinks';
import { FooterReachUs } from '../FooterReachUs';
import { Column, Image, Columns } from '@codeparva/ui-components-library';
import { FooterTypes } from '../footerTypes';
import { useVariant } from '../hooks/VariantContext';
import { footerConstants } from './constants';
import { useThemeContext } from '../hooks/themeContext';
import { getTextColor } from './ColorSelectorHelper';

const listClassName = (variant: string) => {
  switch (variant) {
    case 'footer-1':
      return 'quickLinksListVariantOne';
    case 'footer-2':
      return 'quickLinksListVariantTwo';
    default:
      return 'quickLinksListVariantThree';
  }
};

const QuickLinksAndReachUsHelperFunction = ({
  labelsAndLogos,
  navLinks,
  contactDetailsFooter,
}: FooterTypes.TNavLinks) => {
  const currentVariant = useVariant();
  const currTheme = useThemeContext();
  return (
    <>
      <Column
        className={`${
          currentVariant === 'footer-3'
            ? 'quickLinksVariantThree'
            : 'quickLinksColumn'
        }`}
      >
        {currentVariant === 'footer-1' && (
          <h4 className={`quickLinksLabel has-text-${getTextColor(currTheme)}`}>
            {labelsAndLogos.quickLinksLabel}
          </h4>
        )}
        <ul className={listClassName(currentVariant)}>
          <FooterQuickLinks navLinks={navLinks} />
        </ul>
      </Column>
      {currentVariant === 'footer-1' && (
        <Column className="is-7 reachUsColumn">
          <h4 className={`reachUsLabel has-text-${getTextColor(currTheme)}`}>
            {labelsAndLogos.reachUsLabel}
          </h4>
          <FooterReachUs {...contactDetailsFooter} />
        </Column>
      )}
    </>
  );
};
export const QuickLinksAndReachUsHelper = ({
  labelsAndLogos,
  navLinks,
  contactDetailsFooter,
}: FooterTypes.TNavLinks) => {
  const quickLinksInfo = {
    labelsAndLogos,
    navLinks,
    contactDetailsFooter,
  };
  return <QuickLinksAndReachUsHelperFunction {...quickLinksInfo} />;
};

export const QuickLinksAndReachUsVariants = ({
  quickLinksandReachUsData,
  contactDetails,
  currentVariant,
}: FooterTypes.TQuickLinksReachUsVariants) => {
  const { facilityLogoHeight, facilityLogoWidth } = footerConstants;
  const { facilityLogo, facilityName } = contactDetails.facilityDetails;
  const currTheme = useThemeContext();
  const selectThemeBasedLogo = () => {
    return currTheme === 'light'
      ? facilityLogo.logo.lightTheme
      : facilityLogo.logo.darkTheme;
  };
  if (currentVariant === 'footer-3') {
    return (
      <Columns gap={6} className="quickLinksandReachUsAndLogoVariantThree">
        {facilityLogo && facilityLogo.logo ? (
          <Image
            src={selectThemeBasedLogo()}
            alt={facilityLogo.altText}
            renderAs={facilityLogo.renderAs}
            className={`logo is-${facilityLogoHeight}x${facilityLogoWidth}`}
          ></Image>
        ) : (
          <b>{facilityName}</b>
        )}
        <QuickLinksAndReachUsHelper {...quickLinksandReachUsData} />
      </Columns>
    );
  } else {
    return (
      <Columns
        className={
          currentVariant === 'footer-1'
            ? 'quickLinksandReachUs'
            : 'quickLinksandReachUsVariantTwo'
        }
        multiline={false}
      >
        <QuickLinksAndReachUsHelper {...quickLinksandReachUsData} />
      </Columns>
    );
  }
};
